export default "<span  class=\"card-status-process\">\n  P\n</span>\n"